import moniveaRoadLogo from '../assets/images/moniveaRoadLogo.png';
import heydayLogo from '../assets/images/heydaylogo.svg';
import medreleafLogo from '../assets/images/medreleaf-logo.png';
import isMobile from 'ismobilejs';
import { MoniveaRoadLogoProps } from '../interface/interface';

const target = isMobile(window.navigator).any ? '_self' : '_blank';

const HeyDayLogo = () => (
  <div className="flex justify-start lg:justify-center items-center">
    <a href="/home" className="pr-2 xl:pr-5 border-r border-white">
      <img className="w-full xl:w-72" src={heydayLogo} alt="Heyday logo" />
    </a>
    <a
      className="ml-2 xl:ml-5 flex flex-col justify-between"
      href="https://monivearoad.com.au/"
      target={target}
      rel="noreferrer"
    >
      <span className="text-xxs xl:text-xs text-white mb-1">fulfilled by</span>
      <img
        className="w-full lg:w-3/5 xl:w-72 3xl:w-4/5"
        src={moniveaRoadLogo}
        alt="Monivea Road logo"
      />
    </a>
  </div>
);

const MedReleafLogo = () => (
  <div className="flex justify-start lg:justify-center items-center">
    <a href="/home" className="pr-2 xl:pr-5">
      <img
        className="w-full xl:w-72"
        src={medreleafLogo}
        alt="Medreleaf Clinics logo"
      />
    </a>
    <a
      className="ml-2 xl:ml-5 flex flex-col justify-between"
      href="https://monivearoad.com.au/"
      target={target}
      rel="noreferrer"
    >
      <span className="text-xxs xl:text-xs mb-1">fulfilled by</span>
      <img
        className="w-full lg:w-3/5 xl:w-72 3xl:w-4/5"
        style={{
          backgroundColor: '#818285',
          padding: '2px',
        }}
        src={moniveaRoadLogo}
        alt="Monivea Road logo"
      />
    </a>
  </div>
);

const AuthenticatedUserLogo = ({ isAdmin }: { isAdmin?: boolean }) => (
  <a
    href={`${process.env.CLIENT_APP_URL}/home`}
    className={`flex ${isAdmin ? 'justify-center' : 'justify-start'}`}
  >
    <img
      className="lg:w-1/2 xl:w-68 3xl:w-2/3 sm:w-52 sm:mx-2"
      src={moniveaRoadLogo}
      alt="Monivea Road logo"
    />
  </a>
);

const GuestLogo = () => (
  <a
    href={`${process.env.CLIENT_APP_URL}/guest/shop`}
    className="flex justify-start"
  >
    <img
      className="lg:w-1/2 xl:w-68 3xl:w-2/3 sm:w-52 sm:mx-2"
      src={moniveaRoadLogo}
      alt="Monivea Road logo"
    />
  </a>
);

const DefaultLogo = () => (
  <a
    href="https://monivearoad.com.au/"
    className="flex justify-start lg:justify-center"
  >
    <img
      className="lg:w-3/5 xl:w-72 3xl:w-2/3"
      src={moniveaRoadLogo}
      alt="Monivea Road logo"
    />
  </a>
);

const MoniveaRoadLogo = (props: MoniveaRoadLogoProps) => {
  if (process.env.VITE_THEME_TOGGLE === 'HeyDay') {
    return <HeyDayLogo />;
  }

  if (process.env.VITE_THEME_TOGGLE === 'MedReleaf') {
    return <MedReleafLogo />;
  }

  if (props?.userToken) {
    return <AuthenticatedUserLogo isAdmin={props?.isAdmin} />;
  }

  if (props.isGuest) {
    return <GuestLogo />;
  }

  return <DefaultLogo />;
};

export default MoniveaRoadLogo;
